import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Moment from 'react-moment';
import moment from 'moment';
import { renotificaCondomino } from 'services/condomino/condomino';
import { IconButton } from '@mui/material';
import { Edit } from '@material-ui/icons';
import { updateOrder, updateOrderFull } from "../../services/orders/orders";
import { getAllCondominos } from 'services/condomino/condomino';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import isFirstDayOfMonth from 'date-fns/isFirstDayOfMonth/index';
Moment.globalMoment = moment
Moment.globalLocale = 'pt-br'


const useStyles = theme => ({
    iconView: {
        color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200
        }
    },
    note: {
        lineHeight: '0.5em'
    },
    dialog: {
        '& .MuiPaper-root': {
            margin: theme.spacing(1),
            width: 250,
            height: 250
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    }
});

class InfoOrder extends Component {
    constructor(props) {
        super(props);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClickOpenAlert = this.handleClickOpen.bind(this);
        this.handleCloseAlert = this.handleClose.bind(this);;
        this.editarNotification = this.editarNotification.bind(this);
        this.updateOrders = this.updateOrders.bind(this);
        this.getOrderById = this.getOrderById.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.state = {
            waiting: true,
            order: {},
            statusRenotifica: '',
            mensagemRenotifica: '',
            editing: false,
            condominos: [],
            condomino: {},
            slot: {},
            sizes: [
                {
                    size: "small",
                    pt: "Pequena",
                },
                {
                    size: "medium",
                    pt: "Média",
                },
                {
                    size: "large",
                    pt: "Grande",
                },
                {
                    size: "extra-large",
                    pt: "Extra Grande",
                },
            ]
        }
    }

    componentDidMount() {
        this.getOrderById();
    }

    getOrderById() {
        this.setState({ order: this.props.order, waiting: false });
    }

    handleClickOpen = () => {
        this.props.onChange(true);
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    handleClickOpenAlert = () => {
        this.props.onChange(true);
    };

    handleCloseAlert = () => {
        this.props.onChange(false);
    };

    formatDate(date) {
        let dateArray = date.split('T');
        let data = dateArray[0];
        let time = dateArray[1];

        let anoMesDia = data.split('-');
        let horaMinutos = time.substring(0, 5);

        return `${anoMesDia[2]}/${anoMesDia[1]}/${anoMesDia[0]} ${horaMinutos}`;
    };

    notificarCondomino = () => {
        this.setState({ waiting: true })

        renotificaCondomino({
            orderId: this.state.order.id,
            email: true,
            sms: true,
            whatsapp: true,
        }, (data) => {

            this.setState({ waiting: false })
            this.handleClose();

        })
    };

    editarNotification = (editing) => {
        console.log(JSON.stringify(this.state.order))
        this.onCondominosDados();
        this.setState({ editing: editing })
    }

    onCondominosDados = () => {

        getAllCondominos(this.props.lockerId, (data) => {
            // console.log(JSON.stringify(data));
            data = data.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            const cond = data.find((el) => (el.name == (this.state.order?.condomino?.name || this.state.order?.receiverName)))

            this.setState({ condominos: data, condomino: cond });

            // const grid = data.map(item => {
            //     console.log(JSON.stringify(item))
            //     return item;
            // })
        })

    }

    handleChange = (event) => {
        const obj = event.target.value;

        console.log("===>", JSON.stringify(obj))


        // console.log(JSON.stringify(obj), this.state.cmd, this.state.fields, cmdField);


        this.setState({ condomino: obj });
    }

    updateOrders = () => {
        const { condominoId, receiverPhone, receiverName, receiverEmail, receiverCpf } = this.state.order;


        let orderUp = {
            // condominoId, 
            // receiverPhone, 
            // receiverName, 
            // receiverEmail, 
            // receiverCpf
        };


        if (this.state.order.condomino) {
            orderUp.condominoId = this.state.condomino.id;
        } else {
            orderUp.receiverPhone = this.state.condomino.phone;
            orderUp.receiverName = this.state.condomino.name;
            orderUp.receiverEmail = this.state.condomino.n_email?this.state.condomino.email:"no-reply@meulocker.com.br";
            orderUp.receiverCpf = this.state.condomino.cpf;
        }

        // console.log(JSON.stringify(orderUp), this.props.order.lockerId, this.props.order.id)

        // console.log(JSON.stringify(this.state.condomino))



        updateOrderFull(this.state.order.lockerId, this.state.order.id, orderUp, (data) => {
            //   this.setState({ order: {}, waiting: false });

            console.log(JSON.stringify(data));

            if (data) {
                this.props.setNotification(
                    "Encomenda atualizada com sucesso!",
                    "success"
                )

                if (this.state.order.condomino) {
                    this.setState({ order: { ...this.state.order, condomino: this.state.condomino }, editing: false });
                } else {
                    this.setState({ order: { ...this.state.order, ...orderUp }, editing: false });
                }


            } else {
                this.props.setNotification("Encomenda não foi atualizada!", "danger");
            }
        });
    };



    render() {
        const { classes } = this.props;
        const { sizes } = this.state;

        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{(this.state.waiting) ? "Obtendo informações da Encomenda" : "Histórico da Encomenda"}</DialogTitle>
                    <DialogContent>
                        {(this.state.waiting) ? <div><Circular /></div> :
                            <div>
                                <h7 className={classes.note}>Tamanho da Encomenda: <b>{this.state.order.size ? sizes.filter(s => s.size === this.state.order.size)[0].pt : null}</b></h7><br />
                                <h7 className={classes.note}>PIN de Depósito: <b>{this.state.order.deliveryToken}</b></h7><br />
                                <h7 className={classes.note}>PIN de Coleta: <b>{(this.props.order.collectToken) ? this.props.order.collectToken : '-'}</b></h7><br />
                                <h7 className={classes.note}>Porta: <b>{(this.props.order.slot.label) ? this.props.order.slot.label : '-'}</b></h7><br />
                                <hr></hr>
                                <h7 className={classes.note}>Criada em: <b>{(this.state.order.createdAt) ? this.formatDate(this.state.order.createdAt) : '-'}</b></h7><br />
                                <h7 className={classes.note}>Reservado em: <b>{(this.state.order.reservedAt) ? this.formatDate(this.state.order.reservedAt) : '-'}</b></h7><br />
                                <h7 className={classes.note}>Depositada em: <b>{(this.state.order.allocatedAt) ? this.formatDate(this.state.order.allocatedAt) : '-'}</b></h7><br />
                                <h7 className={classes.note}>Coletada em: <b>{(this.state.order.collectedAt) ? this.formatDate(this.state.order.collectedAt) : '-'}</b></h7><br />
                                <hr></hr>
                                <h7 className={classes.note}>Destinatário: {(!this.state.editing) ? <b>{(this.state.order.condomino) ? this.state.order.condomino.name : (this.state.order.receiverName || '-')}</b> :
                                    <b>
                                        <Select
                                            labelId="demo-controlled-open-select-label"
                                            id="demo-controlled-open-select"
                                            autoWidth={true}
                                            style={{ fullWidth: true, display: 'flex', wrap: 'nowrap' }}
                                            value={this.state.condomino}
                                            // open={open}
                                            // onClose={this.handleClose}
                                            // onOpen={this.handleOpen}
                                            // value={this.state.condominos.find((el) => (el.name == ((this.state.order.condomino) ? this.state.order.condomino.name : (this.state.order.receiverName || '-'))))}
                                            onChange={this.handleChange}
                                        >
                                            {/* <MenuItem value={{}}>
                                                <em>{this.state.condomino?.name || '-'}</em>
                                            </MenuItem> */}
                                            {
                                                this.state.condominos.map((item) =>
                                                    <MenuItem value={item}>{item.name}</MenuItem>
                                                )
                                            }
                                        </Select>
                                    </b>}
                                    <IconButton
                                        aria-label="view"
                                        onClick={() => this.editarNotification(!this.state.editing)}
                                    >
                                        <Edit fontSize='small' className={classes.note} />
                                    </IconButton></h7><br />
                                <h7 className={classes.note}>Email: <b>{(this.state.order.condomino) ? (this.state.order.condomino.email) : (this.state.order.receiverEmail || '-')}</b></h7><br />
                                <h7 className={classes.note}>Celular: <b>{(this.state.order.condomino) ? (this.state.order.condomino.phone) : (this.state.order.receiverPhone || '-')}</b></h7><br />
                                {(this.state.order.condomino) && <>
                                    <h7 className={classes.note}>Apartamento: <b>{(this.state.order.condomino) ? this.state.order.condomino.ap : '-'}</b></h7><br />
                                    <h7 className={classes.note}>Bloco: <b>{(this.state.order.condomino) ? this.state.order.condomino.bloco : '-'}</b></h7><br />
                                    <h7 className={classes.note}>Ala: <b>{(this.state.order.condomino) ? this.state.order.condomino.ala : '-'}</b></h7><br />
                                </>}
                            </div>}
                    </DialogContent>
                    <DialogActions>
                        {(this.state.editing) &&
                            <div><Button onClick={this.updateOrders} color="primary">
                                Atualizar
                            </Button></div>}
                        {(this.state.order.condomino || this.state.order.receiverPhone) &&
                            <div><Button onClick={this.notificarCondomino} color="primary">
                                Reenviar Notificação
                            </Button></div>}
                        {(this.state.waiting) ? null :
                            <div><Button onClick={this.handleClose} color="primary" autoFocus>
                                Fechar
                            </Button></div>}
                    </DialogActions>
                </Dialog>

                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.openAlert}
                    onClose={this.handleCloseAlert}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.statusRenotifica}</DialogTitle>
                    <DialogContent>
                        <div>
                            {this.state.mensagemRenotifica}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <div>
                            <Button onClick={this.handleCloseAlert} color="primary" autoFocus>
                                Fechar
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            </div>


        );
    }
}
export default withStyles(useStyles)(InfoOrder);